import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { store } from './helpers';
import App from './App'
import "react-datepicker/dist/react-datepicker.css"

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)
